import { AutomotiveSchedulerStep } from "JS/automotive/auto-service-scheduler/types/session";

export interface StepInfo<T extends AutomotiveSchedulerStep> {
	step: T;
	previousStep: T extends AutomotiveSchedulerStep.ContactInfo ? null : AutomotiveSchedulerStep;
	nextStep: T extends AutomotiveSchedulerStep.Review ? null : AutomotiveSchedulerStep;
	title: string;
	actionName: string;
}

type StepInfoMap = { [K in AutomotiveSchedulerStep]: Readonly<StepInfo<K>> }

const stepInfoMap: StepInfoMap = {
	[AutomotiveSchedulerStep.ContactInfo]: {
		step: AutomotiveSchedulerStep.ContactInfo,
		previousStep: null,
		nextStep: AutomotiveSchedulerStep.Services,
		title: 'Contact Information',
		actionName: 'Contact Information',
	},
	[AutomotiveSchedulerStep.Services]: {
		step: AutomotiveSchedulerStep.Services,
		previousStep: AutomotiveSchedulerStep.ContactInfo,
		nextStep: AutomotiveSchedulerStep.Appointment,
		title: 'Select Services',
		actionName: 'Service Selection',
	},
	[AutomotiveSchedulerStep.Appointment]: {
		step: AutomotiveSchedulerStep.Appointment,
		previousStep: AutomotiveSchedulerStep.Services,
		nextStep: AutomotiveSchedulerStep.Payment,
		title: 'Select Date & Time',
		actionName: 'Appointment Selection',
	},
	[AutomotiveSchedulerStep.Payment]: {
		step: AutomotiveSchedulerStep.Payment,
		previousStep: AutomotiveSchedulerStep.Appointment,
		nextStep: AutomotiveSchedulerStep.Review,
		title: 'Payment',
		actionName: 'Payment',
	},
	[AutomotiveSchedulerStep.Review]: {
		step: AutomotiveSchedulerStep.Review,
		// Note: will be Payment in a later phase
		previousStep: AutomotiveSchedulerStep.Appointment,
		nextStep: null,
		title: 'Review',
		actionName: 'Review',
	},
};

export function getStepInfo<T extends AutomotiveSchedulerStep>(step: T): StepInfoMap[T]
export function getStepInfo(step: AutomotiveSchedulerStep): StepInfoMap[keyof StepInfoMap]
export function getStepInfo(step: AutomotiveSchedulerStep | null): StepInfoMap[keyof StepInfoMap] | null
export function getStepInfo<T extends AutomotiveSchedulerStep>(step: T | null): StepInfoMap[T] | null {
	if (step == null) {
		return null;
	}

	return stepInfoMap[step];
}

export function getNextStep<T extends AutomotiveSchedulerStep>(step: T): typeof stepInfoMap[T]['nextStep'] {
	return stepInfoMap[step].nextStep;
}

export function getPreviousStep<T extends AutomotiveSchedulerStep>(step: T): typeof stepInfoMap[T]['previousStep'] {
	return stepInfoMap[step].previousStep;
}
